import { Component, OnInit } from '@angular/core';
import { NavigateService } from '../../service/navigate.service';
import { PersonService } from '../../service/person.service';

@Component({
    selector: 'app-message-center',
    templateUrl: './message-center.component.html',
    styleUrls: ['./message-center.component.styl']
})
export class MessageCenterComponent implements OnInit{
    messageList: any = [];
    page: any = {
        pageIndex: 1,
        pageCount: 1,
    };

    constructor(
        private navigateService: NavigateService,
        private personService: PersonService
    ){}

    ngOnInit(){
        this.getMessageList();
    }

    // 获取消息列表
    getMessageList(pageIndex = 1){
        this.page.pageIndex = pageIndex;
        this.personService.getMessageList(pageIndex).subscribe(res => {
            if (res.status === 200){
                this.messageList = res.rows || [];
                this.page.pageCount = Math.ceil(res.total / 10);
            }
        });
    }

    // 详情
    goDetail(messageInfo: any){
        const argsJson = eval(`(${messageInfo.argsJson})`);
        // 跳转至视频详情
        if (messageInfo.messageType === 1 && argsJson.videoSpeechId){
            this.navigateService.push();
            this.navigateService.pushToRoute(`/development/webinar/detail/${argsJson.videoSpeechId}`);
        }
    }
}



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/person/message-center/message-center.component.ts